import { useReactFlow, Handle, Position, NodeResizer } from "@xyflow/react";
import { Button, Input } from "antd";
import { CloseOutlined, CopyOutlined, StarOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const COLOR = "#f59e0b";

const CsatNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? COLOR : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color={COLOR} />
      <Handle type="target" position={Position.Left} style={{ background: COLOR }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <StarOutlined style={{ color: COLOR, fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>CSAT Rating</strong>
        <Button type="text" size="small" icon={<CopyOutlined />}
          onClick={() => data.onDuplicate?.()}
          style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />}
          onClick={() => deleteElements({ nodes: [{ id }] })}
          style={{ color: "#9ca3af" }} />
      </div>

      <div className="nodrag" onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <NodeNameInput data={data} />
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>Question text</div>
          <Input.TextArea
            value={data.question || ""}
            onChange={(e) => data.onChange?.({ ...data, question: e.target.value })}
            rows={2}
            size="small"
            placeholder="How would you rate your experience?"
          />
        </div>

        <div style={{ padding: "8px", background: `${COLOR}11`, borderRadius: 6, fontSize: 11 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Preview (WhatsApp list)</div>
          <div style={{ color: "#78350f" }}>⭐⭐⭐⭐⭐ Excellent (5)</div>
          <div style={{ color: "#78350f" }}>⭐⭐⭐⭐ Good (4)</div>
          <div style={{ color: "#78350f" }}>⭐⭐⭐ Average (3)</div>
          <div style={{ color: "#78350f" }}>⭐⭐ Below average (2)</div>
          <div style={{ color: "#78350f" }}>⭐ Poor (1)</div>
        </div>

        <div style={{ marginTop: 6, fontSize: 10, color: "#9ca3af" }}>
          Rating saved to CSAT collection • viewable per flow
        </div>
      </div>

      <Handle type="source" position={Position.Right} style={{ background: COLOR }} />
    </div>
  );
};

export default CsatNode;
